import { postJson, postToS3, withRetry } from "./upload-video-transport";

// Uploads a custom-workflow video straight to S3 via a presigned POST, bypassing the
// API and its request timeout. A client-transcoded video lands on the final key; a
// deferred original stages at input/ and is handed to server-side MediaConvert.

/**
 * @param {{ videoTranscoded?: string, videoWidth?: string, videoHeight?: string }} body
 *   the hidden fields set by useVideoTranscode
 * @returns {Promise<{fileName: string, uploaderId: string}>}
 *   the value shape workflow-option stores for a video option
 */
export default async function uploadWorkflowVideo({ api, body, files }) {
  const file = files?.videoFile;
  const transcoded = body?.videoTranscoded === "true";

  const presign = await postJson(api, "workflow-video-presign", {
    fileName: file.name,
    contentType: file.type,
    transcoded,
  });

  await postToS3(presign, file);

  // Deferred original staged at input/: the source size lets the server reproduce
  // the bitrate the client would have used. Safe to retry — MediaConvert dedupes
  // on the upload uuid, so a repeat cannot start a second job.
  if (!transcoded) {
    await withRetry(
      () =>
        postJson(api, "workflow-video-finalize", {
          s3Key: presign.s3Key,
          width: body?.videoWidth || undefined,
          height: body?.videoHeight || undefined,
        }),
      "workflow finalize"
    );
  }

  return { fileName: presign.fileName, uploaderId: presign.uploaderId };
}
